import {
  QUERY_STATUS_LABELS,
} from "../constants/query.constants";


export const getQueryStatusLabel = (
  status
) => {
  return (
    QUERY_STATUS_LABELS[status] ||
    status ||
    "-"
  );
};


export const getQueryClientName = (
  query
) => {
  return query?.client_name || "-";
};


export const getQueryClientCompany = (
  query
) => {
  return (
    query?.client_company_name ||
    "-"
  );
};


export const getQueryClientEmail = (
  query
) => {
  return query?.client_email || "-";
};


export const getQueryClientPhone = (
  query
) => {
  return query?.client_phone || "-";
};


export const getQuerySubject = (
  query
) => {
  return query?.subject || "No subject";
};


export const getQueryMessage = (
  query
) => {
  return query?.message || "";
};


export const getQueryOffering = (
  query
) => {
  return query?.offering_name || "-";
};


export const getQueryPricingPlan = (
  query
) => {
  return query?.pricing_plan_name || "-";
};


export const getQueryAssignedUser = (
  query
) => {
  return (
    query?.assigned_user_name ||
    "Unassigned"
  );
};


export const formatQueryDate = (
  value
) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleDateString(
    undefined,
    {
      year: "numeric",
      month: "short",
      day: "numeric",
    }
  );
};


export const formatQueryDateTime = (
  value
) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString(
    undefined,
    {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
  );
};


export const getInitials = (
  name = ""
) => {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(
      (part) =>
        part.charAt(0).toUpperCase()
    )
    .join("");
};